import { Anchor, Badge, Card, Group, Text } from "@mantine/core"
import React from 'react';

interface CustomisedCardProps {
    title: string,
    status: string,
    stage: string,
    applicationURL: string,
    children: React.ReactNode
}

export default function CustomisedCard({title, status, stage, applicationURL, children}: CustomisedCardProps) {
    const statusMapping: { [key: string]: string[] } = {
        '#c85e19': ['INITASSESS', 'PAYMENTRECEIVED', "PUBNOTIFY","ADVTPREP", "INFREQUEST", "ATPRPTNG", "S5057ALODG", "REFERRED", "UNDERASSES", "CON1PLAN","COND1RECVD", "COORDREVIEW"], // Example statuses for green
        '#fc5a86': [], // Example statuses for blue
        '#1a9798': ['APPROVED', "PMTISSUED","ISSUED"], // Example statuses for gray
        // '#1b93cb': ["CANCELLED"], // Example statuses for red
        // Add more color keys and corresponding status arrays as needed
    };
    const getBadgeColor = (status: string) => {

    
        for (const [color, statuses] of Object.entries(statusMapping)) {
            if (statuses.includes(status)) {
                return color;
            }
        }
    
        return 'dark'; // Default color if status doesn't match
    };
    const getAppDetailUrl = (url :string) => {
        if (!url) {
            return "https://copp.t1cloud.com/T1Default/CiAnywhere/Web/COPP/Public/LogOn/PRONLINESERVICE";
        }
        return url;
      };

    const getStatusTitle = (status: string) => {
        const statusColorMapping: { [key: string]: string } = {
            '#c85e19': 'Applied For Permit',
            '#fc5a86': 'Under Assessment',
            '#1a9798': 'Permit Approved',
            '#1b93cb': 'Permit Issued',
            // Add more color keys and corresponding status arrays as needed
        };

        for (const [color, statuses] of Object.entries(statusMapping)) {
            if (statuses.includes(status)) {
                return statusColorMapping[color];
            }
        }

        return 'Unknown Status'; // Default title if status doesn't match any
    };
    return (
        <Card shadow="sm" padding="lg" radius="md" withBorder style={{backgroundColor: "rgba(74, 82, 94, 0.8)", color: "white"}}>
            <Group justify="space-between" mt="md" mb="xs">
                <Text fw={700}>{title}</Text>
                <Badge color={getBadgeColor(stage)}>{getStatusTitle(stage)}</Badge>
            </Group>
            <Text size="sm" c="dimmed">
                {children}
            </Text>
            <Badge style={{ padding: '10px', backgroundColor: 'rgb(216, 235, 227)', textTransform: 'none' }} mb="xs">
              <Anchor
                href={getAppDetailUrl(applicationURL)}
                target="_blank"
                size="sm"
                rel="noopener noreferrer"
                style={{
                  color:"black"
                }}
              >
                Visit OneCouncil Service
              </Anchor>
            </Badge>
        </Card>
    )
} 